import '../stylesheets/application_work_articles';
import 'flatpickr/dist/flatpickr.min.css';
import 'slick-carousel/slick/slick.scss';
import 'slick-carousel/slick/slick-theme.scss';

import 'flatpickr';
import 'flatpickr/dist/l10n/ja';
import 'slick-carousel';
import 'lightbox2';
import 'magnific-popup';
import './popup';

$(function () {
  flatpickr('.js-calendar', {
    dateFormat: 'Y/m/d',
    allowInput: false,
    locale: 'ja',
    onChange: function(selectedDates, dateStr, instance) {
      $('.js-closing-day').val(dateStr)
    },
    onReady: function() {
      if ($('.js-closing-day').length) {
        $('.js-calendar').val($('.js-closing-day').val())
      }
    }
  });
});
